import { render } from "./CustomDatePicker.vue?vue&type=template&id=0fc2d22e"
import script from "./CustomDatePicker.vue?vue&type=script&lang=ts"
export * from "./CustomDatePicker.vue?vue&type=script&lang=ts"

import "./CustomDatePicker.vue?vue&type=style&index=0&id=0fc2d22e&lang=scss"
script.render = render

export default script